import { createPortal } from 'react-dom';
import { X, LayoutGrid, Check } from 'lucide-react';
import { cn } from '@/lib/utils';

/** null = todo o departamento (sem filtro de setor na API) */
type SectorChoice = string | null;

type DashboardSectorPickerModalProps = {
	isOpen: boolean;
	onClose: () => void;
	sectors: CompanyDepartments.CompanySector[];
	selectedSectorId: SectorChoice;
	onSelect: (sectorId: SectorChoice) => void;
};

export function DashboardSectorPickerModal({
	isOpen,
	onClose,
	sectors,
	selectedSectorId,
	onSelect,
}: DashboardSectorPickerModalProps) {
	if (!isOpen) return null;

	return createPortal(
		<div className="fixed inset-0 z-[9999] flex items-center justify-center p-3 sm:p-4">
			<div
				className="absolute inset-0 bg-stone-900/60 backdrop-blur-[2px]"
				onClick={onClose}
			/>
			<div className="animate-in zoom-in-95 relative flex max-h-[90vh] w-full max-w-[520px] flex-col overflow-hidden rounded-[2rem] bg-white shadow-2xl duration-200">
				<div className="flex shrink-0 items-center justify-between border-b border-stone-50 px-4 py-4 sm:px-8 sm:py-6">
					<h2 className="text-lg font-black text-stone-900">
						Escolher setor
					</h2>
					<button
						type="button"
						onClick={onClose}
						className="text-stone-400 transition-colors hover:text-stone-600"
					>
						<X size={20} />
					</button>
				</div>

				<div className="flex-1 overflow-y-auto p-4 sm:p-8">
					<div className="space-y-2">
						<button
							type="button"
							onClick={() => {
								onSelect(null);
								onClose();
							}}
							className={cn(
								'flex w-full items-center gap-3 rounded-2xl border p-4 text-left transition-colors',
								selectedSectorId === null
									? 'border-[#e11d74]/40 bg-pink-50/50'
									: 'border-stone-100 bg-stone-50/50 hover:border-stone-200 hover:bg-white',
							)}
						>
							<LayoutGrid className="size-5 shrink-0 text-stone-500" />
							<span className="flex-1 text-sm font-bold text-stone-900">
								Todo o departamento
							</span>
							{selectedSectorId === null ? (
								<Check className="size-5 shrink-0 text-[#e11d74]" />
							) : null}
						</button>
						{sectors.map((s) => {
							const sel = selectedSectorId === s.id;
							return (
								<button
									key={s.id}
									type="button"
									onClick={() => {
										onSelect(s.id);
										onClose();
									}}
									className={cn(
										'flex w-full items-center gap-3 rounded-2xl border p-4 text-left transition-colors',
										sel
											? 'border-[#e11d74]/40 bg-pink-50/50'
											: 'border-stone-100 bg-stone-50/50 hover:border-stone-200 hover:bg-white',
									)}
								>
									<LayoutGrid className="size-5 shrink-0 text-stone-500" />
									<span className="flex-1 text-sm font-bold text-stone-900">
										{s.name}
									</span>
									{sel ? (
										<Check className="size-5 shrink-0 text-[#e11d74]" />
									) : null}
								</button>
							);
						})}
					</div>
				</div>
			</div>
		</div>,
		document.body,
	);
}
